module.exports = __webpack_public_path__ + "img/CFAFE_~2@2x.edd732e6.png";